module.exports = __webpack_public_path__ + "img/17.334a6956.jpg";